import type { FacetOptions } from "@otto-ec/heureka-components/facet";
import type { FacetValueLabelOptions } from "@otto-ec/heureka-components/facet-value-label";
import type { FacetValueOptions } from "@otto-ec/heureka-components/facet-value";
import type { FacetValueGroupOptions } from "@otto-ec/heureka-components/facet-value-group";
import type { FilterMode, FilterOptions } from "@otto-ec/heureka-components/filter";

export type FacetValueLabelType = "color" | "rating" | "text";
export type FacetValueType = "checkbox" | "chip" | "radio" | "toggle";
export type FacetValueGroupType = "grid" | "list" | "overflowBox";
export type FacetType = "scrollable" | "simple";

export type FacetValueLabelConfiguration = FacetValueLabelOptions & {
  type?: FacetValueLabelType;
};
export type FacetValueConfiguration = FacetValueOptions & {
  type?: FacetValueType;
  facetValueLabelConfig: FacetValueLabelConfiguration;
};
export type FacetValueGroupConfiguration = FacetValueGroupOptions & {
  type?: FacetValueGroupType;
  facetValueConfig: FacetValueConfiguration;
};
export type FacetConfiguration = FacetOptions & {
  type?: FacetType;
  facetValueGroupConfig: FacetValueGroupConfiguration;
};
export type FilterConfiguration = FilterOptions & {
  filterTitleMode?: "onlyTitle";
  facetConfig: FacetConfiguration;
};

export type FacetValueStatus = "unselectedPopular" | "selectedPopular" | "unselected" | "selected";
export type FilterModeConfigurations = {
  default: FilterConfiguration;
  sheetFirstLevel?: FilterConfiguration;
  sheetSecondLevel?: FilterConfiguration;
};

export type ConfigurableFilterOptions = {
  filterConfig: FilterModeConfigurations;
};

export function switchFilterMode(config: FilterModeConfigurations, mode: FilterMode): FilterConfiguration {
  if (!config[mode]) {
    return config.default;
  }
  return config[mode];
}
